
import React, { ReactNode } from 'react';
import Logo from '@/components/Logo';

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      {/* Warm gradient background applied to the content area */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute warm-gradient"></div>
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3z' fill='%23FFDFCE' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E\")",
            opacity: "0.4",
          }}
        ></div>
      </div>

      {/* Content with proper z-index to appear above background */}
      <div className="relative z-30 w-full">
        <div className="mb-6 flex justify-center">
          <Logo />
        </div>

        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
